// ============================================
// PAYMENT TERMS — ONE list, used by every screen
// ============================================
// The subbie Purchase Order prints `subcontractors.payment_terms`, and the subbie's own
// signed agreement states that the PO IS their payment confirmation. So the terms on a PO
// are a contractual statement about what we will pay and when - not a cosmetic label.
//
// WHY THIS FILE EXISTS: the subbie APPROVAL screen (AdminSubbieVerificationDetail) carried
// its own SHORTER list (Prepaid / COD / 7 / 15 / 30 Days) and pre-filled '30 Days'. So
// approving a subbie stamped "30 Days" onto their record - and therefore onto their PO -
// even when the agreed terms were something else entirely (e.g. "50% Booking/50% EPOD").
// Two hand-maintained lists drifting apart is the same fault that broke the trailer types.
// There is now ONE source of truth, and screens must import it rather than re-typing it.
//
// (A value already stored in the database that is NOT in this list is still shown as-is -
// see paymentTermsOptions - so opening an old record never silently rewrites it.)

export const PAYMENT_TERMS_OPTIONS = [
  'Pay in Advance (Prepaid)',
  'COD',
  '7 Days',
  '15 Days',
  '30 Days',
  '50% Booking/50% EPOD',
  '50% Booking/50% Completion'
];

// What to SHOW when nothing is recorded. We never invent a term: a document claiming
// "30 Days" for a subbie nobody ever configured is a commitment no one agreed to.
export const NO_PAYMENT_TERMS = 'Not set';

/** Display-safe label. Never fabricates a term. */
export const paymentTermsLabel = (value) =>
  (value && String(value).trim() ? value : NO_PAYMENT_TERMS);

/**
 * Options for a dropdown, guaranteeing the record's CURRENT value is selectable.
 * Without this, a legacy value (e.g. 'Prepaid') is not in the list, the select falls back
 * to its first option, and saving quietly changes the subbie's agreed terms.
 */
export const paymentTermsOptions = (current) => {
  const v = current && String(current).trim();
  if (v && !PAYMENT_TERMS_OPTIONS.includes(v)) return [v, ...PAYMENT_TERMS_OPTIONS];
  return PAYMENT_TERMS_OPTIONS;
};
